import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";

interface ValorMonedaResponse {
    result: number;
}

const obtenerValorUf = async (codigoMoneda: string, fecha: Date) => {
    const response: Promise<AxiosResponse<ValorMonedaResponse>> = axiosInstance.get(`siscred-api-transversal/v1/monedas/get-valor-moneda?codigoMoneda=${codigoMoneda}&fecha=${fecha.toISOString().split("T")[0]}`,{});
    return response;
}
const obtenerParidadUF = async () =>{
    const response: Promise<AxiosResponse<ValorMonedaResponse>> = axiosInstance.get(`siscred-api-transversal/v1/monedas/get-paridad-uf`,{});
    return response;
}

export {
    obtenerValorUf,
    obtenerParidadUF
};

